export const inboxAppUrl = {
	cpURL: process.env.REACT_APP_URL,
	trackableLinkURL: process.env.REACT_APP_TRACKABLE_LINK_URL
}

export const accountAppUrl = {
	cpURL: process.env.REACT_APP_ACCOUNT_CP_URL
}

export const hubAppUrl = {
	cpURL: process.env.REACT_APP_HUB_CP_URL
}

export const playgroundIAUrl = {
	cpURL: process.env.REACT_APP_PLAYGROUND_IA_URL
}

export const adminConsoleAppUrl = {
	cpURL: process.env.REACT_APP_ADMIN_CONSOLE_CP_URL
}

export const lovableAppUrl = {
	widgetsListURL: process.env.REACT_APP_LOVABLE_WIDGETS_URL,
	widgetEditorURL: process.env.REACT_APP_LOVABLE_WIDGET_EDITOR_URL
}
